export function getTaskClass(task) {
  // F24 (2026-05-10): виртуальная сводная задача (Phase D, _isSummary)
  // тоже использует DHTMLX type='project', но визуально должна отличаться
  // от настоящей строки проекта — иначе после refresh страницы родитель
  // выглядит как ещё один проект (брекеты [ ]). Проверяем _isSummary
  // ПЕРВЫМ, чтобы класс gantt-summary победил gantt-project.
  if (task._isSummary) {
    const cls = ['gantt-summary'];
    if (task._cc) cls.push('gantt-critical');
    return cls.join(' ');
  }

  // Project-row (top-level summary). type сравниваем по строке — модуль
  // ccpm.js не импортирует gantt из dhtmlx, потому проверяем по
  // строке 'project' (тип, который DHTMLX использует для проектов).
  if (task.type === 'project' && !task._isPhase) return 'gantt-project';

  // Feeding buffer (before a milestone) — checked first so it wins over generic buffer class.
  if (task._isFeedingBuffer) return 'gantt-buffer gantt-feeding-buffer';
  if (task._isBuffer)        return 'gantt-buffer';

  // Phase (milestone-парент с children, рендерим как DHTMLX project-row).
  // Wave 7+ Roxber Teal: отдельный визуал — узкая teal-grey полоска с
  // ромбиками-засечками по краям, чтобы отличаться от project-bar.
  if (task._isPhase) {
    const cls = ['gantt-phase'];
    if (task._cc) cls.push('gantt-critical');
    return cls.join(' ');
  }

  // Milestone (diamond) — separate visual axis from regular tasks.
  if (task._isMilestone) {
    const cls = [`gantt-milestone-${task._deadlineType || 'soft'}`];
    if (task._isOverdue) cls.push(`gantt-milestone-overdue-${task._deadlineType || 'soft'}`);
    if (task._cc)        cls.push('gantt-critical');
    return cls.join(' ');
  }

  // Regular task — composition of CC + status (multi-class).
  const classes = [];
  if (task._cc) classes.push('gantt-critical');
  if      (task._status === 'done')        classes.push('gantt-done');
  else if (task._status === 'in_progress') classes.push('gantt-in-progress');
  else if (task._status === 'blocked')     classes.push('gantt-blocked');
  // F6 fix (2026-05-10): отдельная ветка для cancelled. Раньше cancelled
  // попадали в else → 'gantt-todo' (как обычные), и CSS .gantt-cancelled
  // (штриховка + opacity) никогда не применялся. Текст всё равно был
  // зачёркнут отдельно через name-cancelled (gantt.js:65), но bar
  // выглядел «как обычный todo». Теперь cancelled-bar получает свой класс.
  else if (task._status === 'cancelled')   classes.push('gantt-cancelled');
  else                                     classes.push('gantt-todo');
  // Сильный перерасход времени по факту > 200% от плана — визуальный
  // сигнал «здесь была сильная погрешность оценки» (Часть 2 плана).
  if (task._overrunHigh) classes.push('gantt-overrun-high');
  return classes.join(' ');
}

/**
 * Check if a milestone is overdue: the latest planned end of any descendant
 * task lies past `milestone.deadline`.
 *
 * @param {object} milestone — full milestone task row from backend
 *                             (must have `id`, `deadline`).
 * @param {Array}  allTasks  — all task rows in the same project (raw from API).
 * @returns {boolean}
 */
export function isMilestoneOverdue(milestone, allTasks) {
  if (!milestone || !milestone.is_milestone || !milestone.deadline) return false;
  const deadlineMs = new Date(milestone.deadline).getTime();
  if (!Number.isFinite(deadlineMs)) return false;

  // Direct children that are real tasks (skip sub-milestones — their own
  // overdue state is checked recursively when they're rendered).
  let latest = -Infinity;
  for (const t of allTasks) {
    if (t.parent_task_id !== milestone.id) continue;
    if (t.is_milestone) continue;
    if (t.status === 'cancelled') continue;
    // Use end-date if computed, else fall back to planned_end_date.
    const endStr = t.planned_end_date || (t.end ? t.end : null);
    if (!endStr) continue;
    const ms = new Date(endStr).getTime();
    if (Number.isFinite(ms) && ms > latest) latest = ms;
  }
  return latest > deadlineMs;
}

export function bufferDays(project) {
  const mins = project.project_buffer_minutes ?? 0;
  return Math.ceil(mins / 480); // 8h = 1 work day
}

export function worstFeverZone(projects) {
  const zones = projects.map(p => p.fever_zone).filter(Boolean);
  if (zones.includes('red'))    return 'red';
  if (zones.includes('yellow')) return 'yellow';
  if (zones.length)             return 'green';
  return null;
}
